import logo from './logo.svg';
import './App.css';
import * as routeLink from "./constants/routeLink";
import { BrowserRouter as Router, Routes, Route, Navigate, Redirect } from "react-router-dom";
import routers from "./routers";
import Top from "./components/Top/index";
import BottomTabs from "./components/BottomTabs/index";
import { setUser } from './actions/apiIndex';
import { addRef, checkPercentMining, getUser, Login } from './services/services';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    let ref = "";
    if (window.Telegram && window.Telegram.WebApp) {
      const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
      console.log('initDataUnsafe is ', initDataUnsafe);
      if (initDataUnsafe) {
        console.log(initDataUnsafe.start_param);
        const startParam = initDataUnsafe.start_param;
        ref = startParam;
      }


    }
    const login_ = async () => {
      const res = await Login();
      if (res?.code == 200) {
        const user = await getUser();

        if (user.code == 200) {

          // alert(JSON.stringify(user.data));

          dispatch(setUser(user.data));
          // setUser_(user.data);
          if (!user?.data?.refBy) {
            if (ref) {
              const resref = await addRef("user" + ref)
              // alert(JSON.stringify(resref));
            }

          }
        }
      }


    }
    login_();
    // const timer = setTimeout(() => {
    //   setShowSplash(2);
    // }, 2000);


    // return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   setInterval(async () => {
  //     const user = await getUser();
  //     if (user.code == 200) {
  //       dispatch(setUser(user.data));
  //     }
  //   }, 1000);
  // }, []);

  const fetchUser = async () => {
    try {
      const user = await getUser();
      if (user.code === 200) {
        if (user.data) {
          let { miningCreated, balanceMining, withdrawdMiningNew, commission, withdrawd, withdrawdCommission } = user.data;
          let times = Math.floor((Date.now() - miningCreated) / 1000);
          let profit = (balanceMining * times * checkPercentMining(balanceMining) / 259200000);
          let balanceCon = withdrawd + profit;

          if (commission > withdrawdCommission) {
            balanceCon = balanceCon + (commission - withdrawdCommission)
          }

          user.data.profit = balanceCon;
          dispatch(setUser(user.data));
        }
      }
    } catch (error) {
      console.error('Failed to fetch user:', error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchUser();
    }, 1000);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);


  return (
    <Router>
      <ToastContainer />
      <div className='wrapper d-flex justify-content-center align-items-center '>
        <div className='box-mobile  bg-main'>
          <div className='main-content pb-4 mb-4'>
            {/* <Top /> */}

            <Routes>
              {routers.length > 0 &&
                routers.map((route, index) => {
                  console.log(route);
                  return <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    element={route.main({ routers: route.routers })}
                  />
                })}

              <Route path="/" exact element={<Navigate replace to={routeLink.HOME} />} />
            </Routes>
          </div>
          <BottomTabs />
        </div>
      </div>
    </Router>
  );
}

export default App;
